import StateTable from "../../../views/State";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const stateRoutes = [
  {
    menuName: MenuNames.STATE,
    path: "/states",
    component: StateTable,
    exact: true,
  },
  {
    menuName: MenuNames.STATE,
    path: "/states/:id(\\d+)",
    component: StateTable,
    exact: true,
  },
];

export default stateRoutes;
